import React from 'react';
import { inject, observer } from 'mobx-react';
import H5UserPostList from './h5';
import PCUserPostList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';
interface MessageLikeAndFavoriteListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    currentPage?: number;
    pageSize?: number;
    thread?: ThreadAction
    data?: any
    namespace?: string; // 允许外部指定 listStore 命名空间，默认 threadList
    listStore?: any; // 允许外部传入自定义 listStore（例如 topic.listStore）
    searchKeyword?: any // 需要高亮的关键字
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式

}
type MessageLikeAndFavoriteListAllProps = MessageLikeAndFavoriteListProps & RouteComponentProps;
interface MessageLikeAndFavoriteListState {
    recommendUserList: any
}
@inject('app', 'site', 'user', 'thread', 'topic')
@observer
class MessageLikeAndFavoriteList extends React.Component<MessageLikeAndFavoriteListAllProps, MessageLikeAndFavoriteListState> {
    constructor(props) {
        super(props);

        // 从 props 中获取初始值设置到 state
        this.state = {
            recommendUserList: [],
        };
    }
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        
    }

    // 处理触底加载下一页
    handleLoadMore = () => {
    };


    // 去帖子详情页
    goDetails = (item, isPost) => {
        console.log(item, isPost, '参数参数');
        const { thread, listStore } = this.props;
        const store = listStore || thread?.listStore;
        if (store?.setList) {
            // 清空 postList，避免进入新帖详情后沿用上一个帖子的评论
            store.setList({
                namespace: 'postList',
                data: { data: [] },
                page: 1,
                path: 'data',
                hasMore: true
            });
            store.setAttribute?.({
                namespace: 'postList',
                key: 'requestError',
                value: { isError: false, errorText: '' }
            });
        }
        // 进入详情页前清空 threadData，避免展示旧的详情数据
        if (thread && typeof thread.setThreadData === 'function') {
            thread.setThreadData(null);
        }
        // if (this.props.history && item.data?.post?.id) {
            // this.props.history.push(`/threadDetail/${item.id}`);
            if(isPost) {    // 如果是点击评论，给详情页传一个评论id，详情页评论列表第一条就是当前这一条点击的评论数据
                window.open(`/threadDetail/${item.data?.post?.thread?.id}?postId=${item.data?.post?.id}`);
            } else {
                window.open(`/threadDetail/${item.data?.thread?.id ? item.data?.thread?.id : item.data?.post?.thread?.id}`);
            }
            
        // }
    }


    // 去个人中心
    goUser = (user) => {
        console.log('跳转用户中心');
        if (this.props.history && user.code) {
            this.props.history.push(`/user/${user.code}`);
        }
    }

    render() {
        const { site, app, data, thread, onLoadMore, loading: propsLoading, hasMore: propsHasMore, namespace = 'usersPostsList', listStore, searchKeyword, emptyText,  emptyIcon, emptyBoxStyle, ...props } = this.props;
        const platform = app?.platform || 'h5';
        let { recommendUserList } = this.state;
        // 确保传递 data 属性，即使为空数组
        const listData = data || [];

        // 优先使用父组件传递的 loading 和 hasMore，如果没有则从 thread store 获取
        const store = listStore || thread?.listStore;
        const loading = propsLoading !== undefined ? propsLoading : (store?.lists[namespace]?.loading || false);
        const hasMore = propsHasMore !== undefined ? propsHasMore : (store?.lists[namespace]?.hasMore ?? true);

        // 优先使用父组件传递的 onLoadMore，如果没有则使用默认的 handleLoadMore
        const loadMoreHandler = onLoadMore || this.handleLoadMore;

        if (platform === 'pc') {
            return <PCUserPostList
                goDetails={this.goDetails}
                goUser={this.goUser} {...props}
                data={listData}
                loading={loading}
                hasMore={hasMore}
                searchKeyword={searchKeyword}
                onLoadMore={loadMoreHandler}
                emptyText={emptyText}
                emptyIcon={emptyIcon}
                emptyBoxStyle={emptyBoxStyle}
            />;
        } else {
            return <H5UserPostList
            goDetails={this.goDetails}
            {...props} goUser={this.goUser}
            data={listData}
            loading={loading}
            hasMore={hasMore}
            searchKeyword={searchKeyword}
            onLoadMore={loadMoreHandler}
            emptyText={emptyText}
            emptyIcon={emptyIcon}
            emptyBoxStyle={emptyBoxStyle}
        />;
        }
    }
}

export default withRouter(MessageLikeAndFavoriteList);